import React from "react";
import { PageHeader, GoalBar, DisclaimerFooter } from "@/components/Bits";
import { useChallenge } from "@/context/ChallengeContext";
import { fmtUSD } from "@/lib/calc";
import { Target } from "lucide-react";

export default function Goals() {
  const { data } = useChallenge();
  const cfg = data?.config;
  const balance = data?.current_balance ?? 350;

  return (
    <div>
      <PageHeader title="Cele i progres" subtitle={`Aktualny kapitał: ${fmtUSD(balance)}`} />

      <div className="mb-8 max-w-2xl">
        <div className="glow-card rounded-2xl p-8 border-amber-500/30">
          <Target className="text-amber-400 mb-3" size={28} />
          <div className="text-demon-muted text-xs tracking-widest">CEL</div>
          <div className="font-display text-5xl font-extrabold gold-glow text-amber-400 mt-1">$200,000</div>
          <div className="mt-5 space-y-1 font-mono text-sm text-demon-muted">
            <div>Wymagany średni wzrost: <span className="text-white">{cfg?.rate_2 ?? 7.14}% dziennie</span></div>
            <div>Przy 3 turach: <span className="text-white">~{cfg?.per_turn_2 ?? 2.33}% na turę</span></div>
          </div>
          <div className="mt-6">
            <GoalBar label="$350 → $200,000" current={balance} target={200000} color="gold" testid="goals-bar-200k" />
          </div>
        </div>
      </div>

      <p className="text-xs text-demon-muted/80">
        Wartości są matematycznym modelem procentu składanego i nie stanowią gwarancji wyniku.
      </p>
      <DisclaimerFooter />
    </div>
  );
}
